module.exports = __webpack_public_path__ + "static/media/jsicon-orange.8d907a75.svg";